import React from 'react';
import { Button } from '../ui/button';
import { Loader2, Send, Mic, Crown } from 'lucide-react';

const QuestionInput = ({
  language,
  question,
  onChangeQuestion,
  onAsk,
  isLoading,
  isLimitReached,
  isListening,
  toggleListening,
  micPermission,
  isMobile,
  placeholder,
}) => (
  <div className="border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-3 sm:p-4">
    {isLimitReached ? (
      <div className="text-center">
        <p className="text-sm text-red-600 dark:text-red-400 mb-3">
          {language === 'es'
            ? 'Has alcanzado tu límite diario. Actualiza para continuar.'
            : "You've reached your daily limit. Upgrade to continue."}
        </p>
        <Button
          className="bg-gradient-to-r from-yellow-400 to-orange-400 hover:from-yellow-500 hover:to-orange-500 text-white"
          onClick={() => (window.location.href = '/pricing')}
          data-testid="lumera-input-upgrade-btn"
        >
          <Crown className="w-4 h-4 mr-2" />
          {language === 'es' ? 'Actualizar a Lumera+' : 'Upgrade to Lumera+'}
        </Button>
      </div>
    ) : (
      <div className="flex gap-2 max-w-3xl mx-auto">
        <Button
          onClick={toggleListening}
          disabled={isLoading}
          className={`px-3 sm:px-4 ${isListening ? 'bg-red-600 hover:bg-red-700 animate-pulse' : 'bg-purple-600 hover:bg-purple-700'} text-white touch-manipulation`}
          title={language === 'es' ? 'Hablar' : 'Speak'}
          style={{ minHeight: isMobile ? '48px' : '40px', minWidth: isMobile ? '48px' : '40px' }}
          data-testid="lumera-mic-btn"
        >
          <Mic className={`w-5 h-5 ${isListening ? 'animate-bounce' : ''}`} />
          {micPermission === 'denied' && (
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full" />
          )}
        </Button>

        <input
          type="text"
          value={question}
          onChange={(e) => onChangeQuestion(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && onAsk()}
          placeholder={placeholder}
          disabled={isLoading}
          className="flex-1 px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-purple-500 touch-manipulation"
          style={{ minHeight: isMobile ? '48px' : 'auto' }}
          data-testid="lumera-question-input"
        />
        <Button
          onClick={() => onAsk()}
          disabled={isLoading || !question.trim()}
          className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-4 sm:px-6 touch-manipulation"
          style={{ minHeight: isMobile ? '48px' : 'auto' }}
          data-testid="lumera-send-btn"
        >
          {isLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
        </Button>
      </div>
    )}

    {isMobile && micPermission === 'denied' && (
      <p className="text-xs text-red-600 dark:text-red-400 text-center mt-2">
        {language === 'es'
          ? '⚠️ Micrófono bloqueado. Toca el icono 🔒 en la barra de direcciones para habilitarlo.'
          : '⚠️ Microphone blocked. Tap the 🔒 icon in the address bar to enable it.'}
      </p>
    )}
  </div>
);

export default QuestionInput;
